module.exports = __webpack_public_path__ + "static/media/logo_longer.91e15792.png";